<template>
  <v-server-table
    :columns="columns"
    :options="tableOptions"
    @row-click="redirectToEntity"
    id="entitiesTable"
    ref="entitiesTable"
    name="entitiesTable">

    <span slot="cities" class="no-break" slot-scope="props">
      {{ props.row.cities | formatArray}}
    </span>

    <span slot="status" class="no-break" slot-scope="props">
      <span class="small-status-icon align-middle mr-1"
        :class="{'i-evollu-status-active': props.row.status === 0, 'i-evollu-status-pending': props.row.status === 1, 'i-evollu-status-inactive': props.row.status === 2}">
      </span>
      <span>
        {{$t(`entities.status.${props.row.status}`)}}
      </span>
    </span>

  </v-server-table>

</template>

<script>
import TableQueryMixin from '@/mixins/TableQueryMixin'
export default {
  props: {
    querySearch: {
      type: String,
      required: false,
      default: null
    }
  },
  mixins: [
    TableQueryMixin
  ],
  computed: {
    authService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollauth_server) || null
    }
  },
  data: function () {
    return {
      columns: [
        'name',
        'nif',
        'cities',
        'status'
      ],
      queryUrl: `${this.$store.state.evollauth_server}/entities`,
      tableOptions: {
        columnsDropdown: false,
        saveState: true,
        filterable: true,
        sortable: ['created_at'],
        headings: {
          name: this.$t('entities.inputs.name'),
          cities: this.$t('entities.inputs.cities'),
          nif: this.$t('entities.inputs.nif'),
          status: this.$t('entities.inputs.status')
        },
        debounce: 500,
        columnsClasses: {
          results: 'results',
          actions: 'actions',
        }
      }
    }
  },
  methods: {
    refresh: function () {
      this.getTableReference().refresh()
    },
    getTableReference: function () {
      return this.$refs.entitiesTable
    },
    redirectToEntity: function ({ row }) {
      this.$router.push({ name: `${this.authService.slug}entities/id`, params: { id: row.id } })
      //console.log({ name: `${this.authService.slug}entities/id`, params: { id: row.id } })
    }
  },
  filters: {
    formatArray: function (array) {
      if (array == null || array.length < 1) return ''
      return array.join(', ')
    }
  },
  watch: {
    querySearch: function (value) {
      this.getTableReference().setFilter(value)
    }
  }
}
</script>
<style lang="scss">

  $assetsPath: "../../assets";
  @import '@/sass/icons/icons-classes.scss';

  #entitiesTable {
    .VueTables__search {
      display: none;
    }
    tr {
      cursor: pointer;
      &:hover {
        .i-evollu-status-inactive {
          @extend .i-evollu-status-inactive-white;
        }
        .i-evollu-status-pending {
          @extend .i-evollu-status-pending-white;
        }
        .i-evollu-status-active {
          @extend .i-evollu-status-active-white;
        }
      }
    }
    .small-status-icon {
      margin-top: -3px;
    }
  }
</style>
